// const API_BASE_URL = "http://localhost:4000";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const API_BASE_URL = "https://db8b2aa4619f.ngrok-free.app";
const API_ENDPOINTS = {
  users: {
    getAll: `${API_BASE_URL}/api/users`,
    getById: (id) => `${API_BASE_URL}/api/users/${id}`,
  },
  properties: {
    getAll: `${API_BASE_URL}/api/properties`,
    getById: (id) => `${API_BASE_URL}/api/properties/${id}`,
    getUnits: (id) => `${API_BASE_URL}/api/properties/${id}/units`,
    create: `${API_BASE_URL}/api/properties`,
    update: (id) => `${API_BASE_URL}/api/properties/${id}`,
    delete: (id) => `${API_BASE_URL}/api/properties/${id}`,
    getStats: `${API_BASE_URL}/api/properties/stats/overview`,
    markRentPaid: (id) => `${API_BASE_URL}/api/properties/${id}/mark-rent-paid`,
    markManagementPaid: (id) => `${API_BASE_URL}/api/properties/${id}/mark-management-paid`,
    markSold: (id) => `${API_BASE_URL}/api/properties/${id}/mark-sold`,
    markSaleCommissionPaid: (id) =>
      `${API_BASE_URL}/api/properties/${id}/mark-sale-commission-paid`,
    unlinkTenant: (id) => `${API_BASE_URL}/api/properties/${id}/unlink-tenant`,
    linkTenant: (id) => `${API_BASE_URL}/api/properties/${id}/link-tenant`,
    renewLease: (id) => `${API_BASE_URL}/api/properties/${id}/renew-lease`,
    convertToManagement: (id) => `${API_BASE_URL}/api/properties/${id}/convert-to-management`,
    convertToBuilding: (id) => `${API_BASE_URL}/api/properties/${id}/convert-to-building`,
    uploadImages: (id) => `${API_BASE_URL}/api/properties/${id}/images`,
    deleteImage: (id, imageId) => `${API_BASE_URL}/api/properties/${id}/images/${imageId}`,
    getTenants: (property) => `${API_BASE_URL}/api/tenants/lease-history?propertyId=${property.id}`,
  },
  applications: {
    submit: `${API_BASE_URL}/api/applications/submit`,
    getAll: `${API_BASE_URL}/api/applications`,
    getById: (id) => `${API_BASE_URL}/api/applications/${id}`,
    getStats: `${API_BASE_URL}/api/applications/stats/overview`,
    updateReview: (id) => `${API_BASE_URL}/api/applications/${id}/review`,
    updateStatus: (id) => `${API_BASE_URL}/api/applications/${id}`,
    accept: (id) => `${API_BASE_URL}/api/applications/${id}/accept`,
  },
  auth: {
    login: `${API_BASE_URL}/api/auth/login`,
    register: `${API_BASE_URL}/api/auth/register`,
    getProfile: `${API_BASE_URL}/api/auth/me`,
    updateDetails: `${API_BASE_URL}/api/auth/updatedetails`,
    updatePassword: `${API_BASE_URL}/api/auth/updatepassword`,
  },
  tenants: {
    getAll: `${API_BASE_URL}/api/tenants`,
    getById: (id) => `${API_BASE_URL}/api/tenants/${id}`,
    create: `${API_BASE_URL}/api/tenants`,
    update: (id) => `${API_BASE_URL}/api/tenants/${id}`,
    delete: (id) => `${API_BASE_URL}/api/tenants/${id}`,
    getStats: `${API_BASE_URL}/api/tenants/stats/overview`,
    addPayment: (id) => `${API_BASE_URL}/api/tenants/${id}/payments`,
    terminateLease: (id) => `${API_BASE_URL}/api/tenants/${id}/terminate`,
    getLeaseHistory: `${API_BASE_URL}/api/tenants/lease-history`,
  },
  units: {
    getById: (id) => `${API_BASE_URL}/api/properties/${id}`,
    update: (id) => `${API_BASE_URL}/api/properties/${id}`,
    delete: (id) => `${API_BASE_URL}/api/properties/${id}`,
    create: `${API_BASE_URL}/api/properties`,
    markRentPaid: (id) => `${API_BASE_URL}/api/properties/${id}/mark-rent-paid`,
    markManagementPaid: (id) => `${API_BASE_URL}/api/properties/${id}/mark-management-paid`,
    unlinkTenant: (id) => `${API_BASE_URL}/api/properties/${id}/unlink-tenant`,
    linkTenant: (id) => `${API_BASE_URL}/api/properties/${id}/link-tenant`,
    renewLease: (id) => `${API_BASE_URL}/api/properties/${id}/renew-lease`,
    convertToManagement: (id) => `${API_BASE_URL}/api/properties/${id}/convert-to-management`,
  },
  financials: {
    getOverview: (params = "") =>
      `${API_BASE_URL}/api/financials/overview${params ? `?${params}` : ""}`,
  },
  payments: {
    getAll: `${API_BASE_URL}/api/payments`,
    getByProperty: (propertyId) => `${API_BASE_URL}/api/payments?propertyId=${propertyId}`,
    getByTenant: (tenantId) => `${API_BASE_URL}/api/payments?tenantId=${tenantId}`,
  },
  /** Nested under /api/properties so routes always load with the properties router */
  maintenanceTasks: {
    listAll: (status) => {
      const q = new URLSearchParams();
      if (status && status !== "all") q.set("status", status);
      const qs = q.toString();
      return `${API_BASE_URL}/api/maintenance-tasks/all${qs ? `?${qs}` : ""}`;
    },
    list: (propertyId, status) => {
      const q = new URLSearchParams();
      if (status && status !== "all") q.set("status", status);
      const qs = q.toString();
      return `${API_BASE_URL}/api/properties/${propertyId}/maintenance-tasks${qs ? `?${qs}` : ""}`;
    },
    create: (propertyId) => `${API_BASE_URL}/api/properties/${propertyId}/maintenance-tasks`,
    update: (propertyId, taskId) =>
      `${API_BASE_URL}/api/properties/${propertyId}/maintenance-tasks/${taskId}`,
    delete: (propertyId, taskId) =>
      `${API_BASE_URL}/api/properties/${propertyId}/maintenance-tasks/${taskId}`,
  },
};

export { API_BASE_URL, API_ENDPOINTS };
